module.exports = __webpack_public_path__ + "img/zb-not-bound.23a44041.png";